import users from './users';
import roles from './roles';
import permissions from './permissions';
import apps from './apps';
import logs from './logs';
import providers from './providers';

export default {
    namespaced: true,
    modules: {
        users,
        roles,
        permissions,
        apps,
        logs,
        providers,
    }
}